import { CreateActionButton } from '@components/Buttons';
import {
	ManagementKeysGenerationDialog,
	ManagementKeysTable
} from '@components/ManagementKeys';
import { Box } from '@mui/system';
import { ACCESS_KEYS_FIELDS } from 'constants/global';
import React, { FC } from 'react';

const VISIBILITY_MODEL = {
	[ACCESS_KEYS_FIELDS.project]: false,
	[ACCESS_KEYS_FIELDS.hash]: false,
	[ACCESS_KEYS_FIELDS.version]: false,
	[ACCESS_KEYS_FIELDS.modifiedTime]: false,
	[ACCESS_KEYS_FIELDS.id]: false,
	[ACCESS_KEYS_FIELDS.roles]: false,
	[ACCESS_KEYS_FIELDS.tenants]: false
};

const ManagementKeysPage: FC = () => {
	const actions = React.useMemo(
		() => [
			<CreateActionButton
				key="add-management-key"
				Dialog={ManagementKeysGenerationDialog}
				buttonLabel={intl.tr('managementKeys.table.action.add.button')}
			/>
		],
		[]
	);

	return (
		<Box
			data-testid="management-keys-page"
			id="management-keys"
			display="flex"
			flexGrow={1}
			flexDirection="column"
			overflow="hidden"
		>
			<ManagementKeysTable
				columnVisibilityModel={VISIBILITY_MODEL}
				actions={actions}
			/>
		</Box>
	);
};

export default ManagementKeysPage;
